import LimitedTimeOffer from './LimitedTimeOffer';
export default LimitedTimeOffer;
